// combatpro/treasure/treasureVocab.js
//
// Canonical Treasure vocabulary + tuning maps used by the engine and UI. These are
// engine constants, NOT content: the content catalogue (items / profiles / presets)
// is external data loaded through the manifest (public/data/treasure). No DOM, no
// optional chaining, no em dash.

// Category ids (must match manifest.vocab.categories and item.category values).
export var CATEGORIES = [
  'coins', 'gems', 'jewellery', 'mundane_equipment', 'weapons_armour', 'consumables',
  'magic_items', 'tools_trade', 'documents_keys', 'curios', 'components', 'special_quest'
];

export var CATEGORY_LABELS = {
  coins: 'Coins', gems: 'Gems', jewellery: 'Jewellery / Art', mundane_equipment: 'Mundane Equipment',
  weapons_armour: 'Weapons / Armour', consumables: 'Consumables', magic_items: 'Magic Items',
  tools_trade: 'Tools / Trade Goods', documents_keys: 'Documents / Keys', curios: 'Curios / Personal Effects',
  components: 'Components / Harvestables', special_quest: 'Special / Quest'
};

export var RARITIES = ['common', 'uncommon', 'rare', 'very_rare', 'legendary', 'special'];
export var WEALTH_TIERS = ['poor', 'standard', 'rich', 'exceptional'];
export var MODES = ['individual', 'group', 'hoard', 'container', 'reward', 'custom'];
export var QUANTITIES = ['sparse', 'normal', 'generous', 'huge', 'custom'];

// Wealth tier ordinal (an item is eligible when itemTierRank <= requestedTierRank).
export var WEALTH_RANK = { poor: 0, standard: 1, rich: 2, exceptional: 3 };

// Base rarity weight curve, then scaled by wealth and level and profile rarityBias.
export var RARITY_BASE_WEIGHT = { common: 100, uncommon: 45, rare: 14, very_rare: 4, legendary: 1, special: 3 };

// Wealth scales how much the high rarities are boosted.
export var WEALTH_RARITY_BOOST = {
  poor:        { common: 1.3, uncommon: 0.6, rare: 0.2, very_rare: 0.05, legendary: 0.02, special: 0.6 },
  standard:    { common: 1.0, uncommon: 1.0, rare: 1.0, very_rare: 1.0, legendary: 1.0, special: 1.0 },
  rich:        { common: 0.7, uncommon: 1.2, rare: 1.8, very_rare: 2.2, legendary: 2.0, special: 1.3 },
  exceptional: { common: 0.4, uncommon: 1.0, rare: 2.2, very_rare: 3.5, legendary: 4.0, special: 1.6 }
};

// How many item picks a mode+quantity produces (before per-pick category weighting).
export var QUANTITY_PICKS = {
  sparse:   { individual: 1, group: 2, hoard: 4, container: 2, reward: 1, custom: 2 },
  normal:   { individual: 2, group: 4, hoard: 7, container: 4, reward: 3, custom: 4 },
  generous: { individual: 3, group: 6, hoard: 11, container: 6, reward: 5, custom: 6 },
  huge:     { individual: 5, group: 10, hoard: 18, container: 10, reward: 8, custom: 10 }
};

// Baseline coin value (in base units) per level, before wealth + profile multipliers.
export var COIN_BASE_PER_LEVEL = 900; // ~9 gp per level at standard, tuned by multipliers
export var WEALTH_COIN_MULT = { poor: 0.4, standard: 1, rich: 2.4, exceptional: 5 };

export function clampLevel(n) {
  var v = parseInt(n, 10);
  if (isNaN(v)) { return 1; }
  if (v < 0) { return 0; }
  if (v > 40) { return 40; }
  return v;
}
